import React from 'react';
import DashboardTabs from '@components/common/Dashboard/DashboardTabs';
import styled from 'styled-components';

const TabWrapper = styled.div`
  position: absolute;
  width: 100%;
`;
// eslint-disable-next-line react/display-name
export default (props) => {
  const { currentShareId } = props;

  let pageType = -1;
  if (props.pageType) {
    pageType = props.pageType;
  }

  return (
    <TabWrapper>
      <DashboardTabs
        pageType={pageType}
        id={currentShareId}
      />
    </TabWrapper>
  );
};
